import { addDays, isAfter } from 'date-fns';
import { CalendarEventDetailsFragment } from 'generated/graphql';
import { localDate } from './date-fns-local';
import { sortByStartDate } from './sort-by-start-date';

export const eventsByDay = (newEvents: CalendarEventDetailsFragment[], onlyShowEventsOnFirstDay = false) => {
  if (!newEvents) { return []; }
  // Create a map to group events by day
  const eventMap = new Map<string, CalendarEventDetailsFragment[]>();

  // Iterate through the events and organize them by day
  newEvents
    .forEach(event => {
      const date = localDate(event.startDate);
      date.setHours(0, 0, 0);
      const key = date.toDateString();
      if (!eventMap.has(key)) {
        eventMap.set(key, []);
      }

      // Check if event spans multiple days
      if (!event.endDate || onlyShowEventsOnFirstDay) {
        eventMap.get(key).push(event);
      } else {
        const endDate = localDate(event.endDate);
        let currentDate = date;
        currentDate.setHours(0, 0, 0);
        // Add event to each day through endDate
        while (!isAfter(currentDate, endDate)) {
          const dateKey = currentDate.toDateString();
          if (!eventMap.has(dateKey)) {
            eventMap.set(dateKey, []);
          }
          eventMap.get(dateKey).push(event);

          currentDate = addDays(currentDate, 1);
        }
      }
    });

  // Convert the map to an array of objects
  const organizedEvents = Array.from(eventMap, ([date, events]) => ({
    date, events: events.sort(sortByStartDate)
  }));

  return organizedEvents;
};
